module.exports = __webpack_public_path__ + "img/RastreamentoMenu.3b10f9e6.png";